import angular from 'angular'

import envRaw from '../utils/env-raw'
import attachGetters from '../utils/attach-getters'
import attachSetters from '../utils/attach-setters'
import extractRawElm from '../utils/extract-raw-elm'

import { defaultTo } from '../utils/bits'
import { offClick, onClickPassive } from '../utils/on-click'
import { find, compact, partial, uniqueId } from 'lodash-es'

import Template from './ggs-list-select.component.ejs'

angular
  .module('ggs.list-select')
  .component('ggsListSelect', {
    template: Template({
      LE: envRaw.liveEditMode
    }),
    controller: ListSelectComponent,
    bindings: {
      listSelectSync: '<',
      listSelectColor: '<',
      listSelectOptions: '<',
      listSelectCompacts: '<',
      listSelectApplyOption: '<'
    }
  })

const QS_SELECT_MAIN = '.ggs-select__main'
const QS_SELECT_ICON = '.ggs-select__current-icon_real'
const QS_SELECT_TEXT = '.ggs-select__current-text_real'

const MAIN_OPEN = 'ggs-select__main_open'
const MAIN_WAIT = 'ggs-select__main_wait'

const ICON_FA_OPEN = 'ggs-fa ggs-fa-chevron-down'
const ICON_FA_FAIL = 'ggs-fa ggs-fa-times'
const ICON_FA_WAIT = 'ggs-fa ggs-fa-circle-o-notch ggs-fa-spin'

const MODE_FAIL = 'ggs-select__mode_fail'
const MODE_SHOW = 'ggs-select__mode_show'

const CLICK_EVENT = envRaw.listSelectClickEvent

function ListSelectComponent(
  qh,
  domh,
  $scope,
  $element,
  StayInQueue,
  DefineMethod,
  DefineHandler) {

  $scope.CLICK_EVENT = CLICK_EVENT

  const sign = `listSelect[uid=${uniqueId()}]`
  const $ctrl = $scope.$ctrl = attachGetters(attachSetters(this))
  $ctrl.wrapH = DefineHandler(sign)
  $ctrl.wrapM = DefineMethod(sign)
  const stayInQueue = StayInQueue(sign)

  const mainElm = domh.find($element, QS_SELECT_MAIN)
  const iconElm = domh.find($element, QS_SELECT_ICON)
  const textElm = domh.find($element, QS_SELECT_TEXT)

  $ctrl.isOpen = false
  $ctrl.currOption = null

  // syncChangeHandler
  $ctrl.wrapM('updateCurrOption', () => {
    const realOption = find($ctrl.listSelectOptions, { value: $ctrl.listSelectSync })
    const safeOption = defaultTo(realOption, null)
    $ctrl.currOption = safeOption
  })

  $ctrl.wrapH('syncChangeHandler',
    stayInQueue.make(
      $ctrl.updateCurrOption))

  $scope.$watch(
    $ctrl.getters.listSelectSync,
    $ctrl.syncChangeHandler)

  // toggleRequestHandler
  $ctrl.wrapM('openList',
    qh.makeOver(
      openElms,
      $ctrl.setters.bindTrue.isOpen))

  $ctrl.wrapM('closeList',
    qh.makeOver(
      closeElms,
      $ctrl.setters.bindFalse.isOpen))

  $ctrl.wrapH('toggleRequestHandler',
    stayInQueue.makeIfIdle(
      qh.makeIfElse(
        $ctrl.getters.isOpen,
        $ctrl.closeList,
        $ctrl.openList)))

  // closeRequestHandler
  $ctrl.wrapH('closeRequestHandler',
    stayInQueue.makeIfIdle(
      qh.makeIf(
        $ctrl.getters.isOpen,
        $ctrl.closeList)))

  // selectHandler
  $ctrl.wrapM('animateWait',
    qh.makeOver(
      hideIconElm,
      delayShort,
      waitElms))

  $ctrl.wrapM('animateSuccess',
    qh.makeOver(
      hideIconElm,
      delayShort,
      closeElms))

  $ctrl.wrapM('animateProblem',
    qh.makeOver(
      hideIconElm,
      delayShort,
      failElms,
      delayLong,
      hideIconElm,
      hideTextElm,
      delayShort,
      closeElms))

  $ctrl.wrapM('applyOption',
    qh.makeUnless(
      qh.eqWith($ctrl.getters.currOption),
      qh.makeOver(
        $ctrl.setters.currOption,
        $ctrl.animateWait,
        qh.makeFork(
          $ctrl.listSelectApplyOption,
          $ctrl.animateSuccess,
          $ctrl.animateProblem),
        $ctrl.updateCurrOption)))

  $ctrl.wrapH('selectHandler',
    stayInQueue.makeIfIdle(
      qh.makeJoin(
        $ctrl.closeList,
        $ctrl.applyOption)))

  // $onInit
  $ctrl.wrapM('subscribe',
    partial(onClickPassive, window, CLICK_EVENT, $ctrl.closeRequestHandler))

  $ctrl.wrapH('$onInit',
    stayInQueue.make(
      qh.makeJoin(
        $ctrl.closeList,
        $ctrl.subscribe,
        $ctrl.updateCurrOption)))

  // $onDestroy
  $ctrl.wrapM('unsubscribe',
    partial(offClick, window, CLICK_EVENT, $ctrl.closeRequestHandler))

  $ctrl.wrapH('$onDestroy',
    qh.makeJoin(
      $ctrl.closeList,
      $ctrl.unsubscribe))

  // helpers
  function delayShort() {
    return qh.delay(0.3e3)
  }

  function delayLong() {
    return qh.delay(1.5e3)
  }

  function closeElms() {
    resetMainElm()
    addClasses(resetIconElm(), MODE_SHOW, ICON_FA_OPEN)
    addClasses(resetTextElm(), MODE_SHOW)
  }

  function openElms() {
    addClasses(resetMainElm(), MAIN_OPEN)
    addClasses(resetIconElm(), MODE_SHOW, ICON_FA_OPEN)
    addClasses(resetTextElm(), MODE_SHOW)
  }

  function waitElms() {
    addClasses(resetMainElm(), MAIN_WAIT)
    addClasses(resetIconElm(), MODE_SHOW, ICON_FA_WAIT)
    addClasses(resetTextElm(), MODE_SHOW)
  }

  function failElms() {
    addClasses(resetMainElm(), MAIN_WAIT)
    addClasses(resetIconElm(), MODE_SHOW, MODE_FAIL, ICON_FA_FAIL)
    addClasses(resetTextElm(), MODE_SHOW, MODE_FAIL)
  }

  function resetMainElm() {
    return removeClasses(mainElm,
      MAIN_OPEN,
      MAIN_WAIT)
  }

  function resetIconElm() {
    return removeClasses(iconElm,
      ICON_FA_OPEN,
      ICON_FA_FAIL,
      ICON_FA_WAIT,
      MODE_FAIL,
      MODE_SHOW)
  }

  function hideIconElm() {
    return removeClasses(iconElm, MODE_SHOW)
  }

  function resetTextElm() {
    return removeClasses(textElm,
      MODE_FAIL,
      MODE_SHOW)
  }

  function hideTextElm() {
    return removeClasses(textElm, MODE_SHOW)
  }

  function addClasses($elm, ...input) {
    const elm = extractRawElm($elm)
    const classes = compact(input.join(' ').split(' '))
    elm.classList.add(...classes)
    return $elm
  }

  function removeClasses($elm, ...input) {
    const elm = extractRawElm($elm)
    const classes = compact(input.join(' ').split(' '))
    elm.classList.remove(...classes)
    return $elm
  }
}
